var _rect, _rect2, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgGnosis = function SvgGnosis(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 50,
    fill: "#007B59"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 50,
    fill: "url(#007B59)",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.054 19.665c.69 0 1.363-.23 1.907-.65l-4.374-4.374a3.124 3.124 0 0 0 .56 4.38c.55.415 1.218.644 1.907.644Zm13.01-3.123c0-.69-.23-1.363-.65-1.907l-4.375 4.374a3.117 3.117 0 0 0 5.025-2.467Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.267 11.781-1.934 1.935a4.409 4.409 0 0 1-.555 6.207 4.405 4.405 0 0 1-5.653 0L18 22.05l-2.12-2.12a4.409 4.409 0 0 1-6.207-.555 4.405 4.405 0 0 1 0-5.653l-.993-.992-.942-.948A11.976 11.976 0 0 0 6 18c0 6.628 5.372 12 12 12s12-5.372 12-12c.006-2.193-.6-4.346-1.733-6.219Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.68 9.718c-4.57-4.795-12.162-4.974-16.957-.404a12.712 12.712 0 0 0-1.245 1.385L18 20.226l9.521-9.527a11.58 11.58 0 0 0-.84-.981ZM18 7.57c2.804 0 5.417 1.082 7.38 3.056L18 18.006l-7.38-7.38A10.318 10.318 0 0 1 18 7.57Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 18 -18 0 18 18)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007B59"
  })))));
};
export default SvgGnosis;